import { extend } from 'vee-validate'

import { required, email, numeric } from 'vee-validate/dist/rules'

import dayjs from 'dayjs'

import i18n from '@/i18n'

extend('required', required)

extend('email', email)

extend('numeric', numeric)

extend('date_format', {
  validate: value => {
    return dayjs(value, i18n.t('mask.date.formatShow')).isValid()
  }
})

extend('decimal', {
  validate: value => {
    return value !== Math.floor(value)
  }
})
